/* Resolving an account id to what it is called.

   Ids are stored on every holding, trade and cash flow, so they outlive the
   broker list — an id whose record has been deleted still has to render as
   something a human can read rather than vanishing. */

import type { Account, AccountRecord } from '../types';

/** No id at all means the record is not about one account — a deposit paid into
    the book rather than into a broker. It reads as that rather than as blank. */
export function accountName(accounts: AccountRecord[], id: Account | undefined): string {
  if (!id) return 'across the book';
  return accounts.find((a) => a.id === id)?.name ?? id;
}

export function accountNames(accounts: AccountRecord[], ids: Account[]): string {
  return ids.map((id) => accountName(accounts, id)).join(' \u00b7 ');
}

export function isTaxShielded(accounts: AccountRecord[], id: Account): boolean {
  return accounts.find((a) => a.id === id)?.taxShielded === true;
}

/** A stable id from a typed-in name: lowercase, words joined by underscores.
    Collisions are the caller's to resolve. */
export function idFromName(name: string): string {
  return name.trim().toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 32) || `broker_${Date.now().toString(36)}`;
}
